/* prettier-ignore */

import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import QRCode from 'qrcode';

@Component({
  selector: 'app-passport-qr-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './passport-qr-dialog.component.html',
  styleUrls: ['./passport-qr-dialog.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PassportQrDialogComponent implements OnInit {
  private _dialogRef = inject(MatDialogRef<PassportQrDialogComponent>);

  protected qr = signal<string>('');

  ngOnInit(): void {
    const origin = window.location.origin;
    QRCode.toDataURL(origin, { errorCorrectionLevel: 'H' }, (_err, dataUrl) => {
      this.qr.set(dataUrl ?? '');
    });
  }

  protected close(): void {
    this._dialogRef.close();
  }
}
